export const investments = () => {
  const container = document.querySelector('.wp-block-investments');
  if (!container) {
    return;
  }

  // Delegate so toggles still work after filter/pagination replaces the grid
  container.addEventListener('click', (e) => {
    const company = e.target.closest('.investments-item .investments-item__company');
    if (!company) {
      return;
    }

    e.preventDefault();
    company.closest('.investments-item')?.classList.toggle('is-active');
  });
};
